/** Коллекции на внешнем PocketBase (CRM): авторизация и справочники только для чтения в SPA */
export const COL_CRM_USERS = 'users'
export const COL_CRM_ROLES = 'roles'
export const COL_CRM_CLIENTS = 'clients'
export const COL_CRM_EVEREST_CLIENTS = 'everest_clients'
